<!--
 * @Description: 侧边栏菜单
 * @Autor: lwq
 * @Date: 2020-07-24 18:28:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-04 11:10:09
 * @FilePath: \mrc-base-server-view\src\LAYOUT\sideMenu.vue
--> 
<template>
  <div>
    <!-- <logo></logo> -->
    <!-- :mini-variant="miniVariant" -->
    <!-- (fullWidth<1264?0:240) -->
    <!-- :width="miniVariant?0:240" -->
    <v-navigation-drawer v-model="drawer"
                         :clipped="$vuetify.breakpoint.lgAndUp"
                         app>
      <!-- background: #0F46C1; -->
      <side-menu :style="{height:height ,overflowY: 'auto'}"
                 :list='list'
                 :depth='0'></side-menu>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import sideMenu from './sideCompany'
import logo from './logo'
export default {
  components: { sideMenu, logo },
  props: {},
  data () {
    return {
      fullWidth: document.documentElement.clientWidth,
      drawer: null,
    };
  },
  validations: {},
  computed: {
    miniVariant () {
      return this.$store.state.miniVariant
    },
    list () {
      return this.$store.state.currentCopmpanyMenu
      // return data[0].data.menus_tree
    },
    height () {
      return this.$store.state.calcHeight
    },
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  watch: {
    fullWidth (v) {
      if (v < 1264) {
        this.$store.commit('set_miniVariant', true)
      }
    }
  },
  mounted () {
    if (this.fullWidth < 1264) {
      this.$store.commit('set_miniVariant', true)
    }
    // this.listHeight = document.documentElement.clientHeight - 48 + 'px'
    // console.log(this.list);
  },
  beforeRouteUpdate () { },
  methods: {
    changeDrawer () {
      this.drawer = !this.drawer
    },
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
};
</script>

<style scoped>
</style>
